module.exports = __webpack_public_path__ + "img/Patient Report.2b68e698.svg";